import React from 'react';

const Intro = () => {
    return (
        <section id='intro'>
            <h1>Hello, my name is <span className='first-name'>Christian</span> <span className='last-name'>Arneson</span>. I am a <span className='role'>Full Stack Web Developer</span> living in <span className='location'>Denver, CO</span>.</h1>
            <div className='social-icons'>
                <a rel='noopener noreferrer' target='_blank' href='https://github.com/christiano39'><i className='fab fa-github'></i></a>
                <a rel='noopener noreferrer' target='_blank' href='https://twitter.com/I_Am_Become_Dev'><i className='fab fa-twitter'></i></a>
                <a rel='noopener noreferrer' target='_blank' href='https://www.linkedin.com/in/christianthedev/'><i className='fab fa-linkedin'></i></a>
            </div>
        </section>
    )
}

export default Intro;